import styled from 'styled-components'

export const Title = styled.p`
  position: relative;
  display: block;
  width: 115%;
  height: 8%;

  font-family: 'Crash';
  font-size: 2em;
  background: -webkit-linear-gradient(#feaf12, #ff4304);
  -webkit-text-stroke: 0.7px rgb(0, 0, 0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  transform: scaleX(0.85);
  transform-origin: 0;
  
  &::before{
    position: absolute;
    top: 80%;
    transform: scaleX(1);
    transform-origin: 0;

    display: block;
    height: 2px;
    width: 75%;

    content: "";
    background: #FFF;
    border-radius: 5px;

    @media screen and (max-width: 812px) {
      top: 27px;
      left: 50%;
      transform: translate(-50%) scaleX(1);
    }
  }

  @media screen and (max-width: 812px) {
    height: 35px;
    font-size: 1.75em;
    text-align: center;
  }
`

export const Text = styled.p`
  display: block;
  width: 100%;
  height: 40%;

  color: #FFF;
  font-family: 'Barthowheel-Regular';
  font-size: 1.15em;

  @media screen and (max-width: 812px) {
    height: 70px;
    /* font-size: 1em; */
    padding-bottom: 0.5em;
    text-align: center;
  }
`

export const NitroImg = styled.img`
  width: 25px;
  height: 25px;
  padding-right: 0.3em;

  transform: translate(0, 5px);
`